import { render } from "./AnnotationEditorGallery.vue?vue&type=template&id=c13d37f8&scoped=true"
import script from "./AnnotationEditorGallery.vue?vue&type=script&lang=js"
export * from "./AnnotationEditorGallery.vue?vue&type=script&lang=js"

import "./AnnotationEditorGallery.vue?vue&type=style&index=0&id=c13d37f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c13d37f8"]])

export default __exports__